'use client';

import { alpha, Box, Grid, Skeleton } from '@mui/material';

export const TraderProfileCardSkeleton = () => {
  return (
    <Box
      sx={{
        bgcolor: 'background.paper',
        color: 'text.primary',
        borderRadius: 4,
        border: '1px solid',
        borderColor: 'divider',
        height: '100%',
        p: 1.5,
        overflow: 'hidden',
      }}
    >
      {/* Header Section Skeleton */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
        <Skeleton
          variant="circular"
          width={48}
          height={48}
          sx={{ bgcolor: (theme) => alpha(theme.palette.text.primary, 0.1), flexShrink: 0 }}
        />
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.2 }}>
            <Skeleton
              variant="text"
              width="60%"
              height={32}
              sx={{ bgcolor: (theme) => alpha(theme.palette.text.primary, 0.1) }}
            />
          </Box>
          <Skeleton
            variant="text"
            width="40%"
            height={20}
            sx={{ bgcolor: (theme) => alpha(theme.palette.text.primary, 0.1) }}
          />
        </Box>
      </Box>

      {/* Stats Section Skeleton */}
      <Grid container>
        {[1, 2, 3].map((i) => (
          <Grid item key={i} sx={{ display: 'flex', alignItems: 'center' }}>
            <Box>
              <Skeleton
                variant="text"
                width={80}
                height={20}
                sx={{ bgcolor: (theme) => alpha(theme.palette.text.primary, 0.1), mb: 0.3 }}
              />
              <Skeleton
                variant="text"
                width={100}
                height={32}
                sx={{ bgcolor: (theme) => alpha(theme.palette.text.primary, 0.1) }}
              />
            </Box>
            {i < 3 && (
              <Box
                sx={{
                  width: '1px',
                  height: 32,
                  bgcolor: (theme) => alpha(theme.palette.divider, 0.2),
                  mx: 2,
                  mt: 0.5,
                  display: { xs: 'none', sm: 'block' },
                }}
              />
            )}
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TraderProfileCardSkeleton;
